import { Button, Grid, TextField, MenuItem } from '@mui/material';
import { useFormik } from 'formik';
import { React, useEffect, useState } from 'react';
import * as yup from 'yup';
import useStyles from '../theme/formCssStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from "@mui/material/styles";

export default function S7000ConfigForm(props) {
    const classes = useStyles();
    const muiTheme = useTheme();
    const isSmallScreen = useMediaQuery(muiTheme.breakpoints.down('sm'));
    const [isAddOperation, setIsAddOperation] = useState(false);
    
    const [recvValues, setRecvValues] = useState({
        id: null,
        reg_code: '',
        user: '',
        webpass: '',
        URL: '',
        frequency: ''
    });

    useEffect(() => {
        if (props.selectedRow !== null) {
            setRecvValues({
                id: props.selectedRow.id,
                reg_code: props.selectedRow.reg_code || '',
                user: props.selectedRow.user || '',
                webpass: props.selectedRow.webpass || '',
                URL: props.selectedRow.URL || '',
                // frequency 0=Daily, 1=Hourly, 2=Weekly. Coerce to Number so it
                // matches the numeric menu values, and keep 0 (|| '' would blank it).
                frequency: (props.selectedRow.frequency === null || props.selectedRow.frequency === undefined || props.selectedRow.frequency === '')
                    ? ''
                    : Number(props.selectedRow.frequency)
            });
            setIsAddOperation(false);
        } else {
            setRecvValues({
                id: null,
                reg_code: '',
                user: '',
                webpass: '',
                URL: '',
                frequency: ''
            });
            setIsAddOperation(true);
        }
    }, [props.selectedRow]);

    const validationSchema = yup.object({
        reg_code: yup.string().required("Please enter Reg Code"),
        user: yup.string().required("Please enter User"),
        webpass: yup.string().required("Please enter Webpass"),
        URL: yup.string().required("Please enter URL"),
        frequency: yup.string().required("Please enter Frequency")
    });

    function onCancelForm() {
        props.handleSubmit(null, isAddOperation, true);
    }

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: recvValues,
        onSubmit: (values) => {
            props.handleSubmit(values, isAddOperation, false);
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid item container xs={12} spacing={2} justifyContent="flex-start" alignItems='flex-start' direction="row">
                <Grid item xs={12} sm={12} md={12}></Grid>
                
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        fullWidth
                        variant='outlined'
                        id="reg_code"
                        name="reg_code"
                        label="Reg Code"
                        value={formik.values.reg_code}
                        onChange={formik.handleChange}
                        error={formik.touched.reg_code && Boolean(formik.errors.reg_code)}
                        helperText={formik.touched.reg_code && formik.errors.reg_code}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        fullWidth
                        variant='outlined'
                        id="user"
                        name="user"
                        label="User"
                        value={formik.values.user}
                        onChange={formik.handleChange}
                        error={formik.touched.user && Boolean(formik.errors.user)}
                        helperText={formik.touched.user && formik.errors.user}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        fullWidth
                        variant='outlined'
                        /* type="password" */
                        id="webpass"
                        name="webpass"
                        label="Webpass"
                        value={formik.values.webpass}
                        onChange={formik.handleChange}
                        error={formik.touched.webpass && Boolean(formik.errors.webpass)}
                        helperText={formik.touched.webpass && formik.errors.webpass}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        fullWidth
                        variant='outlined'
                        id="URL"
                        name="URL"
                        label="URL"
                        value={formik.values.URL}
                        onChange={formik.handleChange}
                        error={formik.touched.URL && Boolean(formik.errors.URL)}
                        helperText={formik.touched.URL && formik.errors.URL}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={5}>
                    <TextField
                        fullWidth
                        select
                        variant='outlined'
                        id="frequency"
                        name="frequency"
                        label="Frequency"
                        value={formik.values.frequency}
                        onChange={formik.handleChange}
                        error={formik.touched.frequency && Boolean(formik.errors.frequency)}
                        helperText={formik.touched.frequency && formik.errors.frequency}
                    >
                        <MenuItem value={0}>0 - Daily</MenuItem>
                        <MenuItem value={1}>1 - Hourly</MenuItem>
                        <MenuItem value={2}>2 - Weekly</MenuItem>
                    </TextField>
                </Grid>
                
                <Grid item container xs={12} spacing={2} justifyContent="flex-start">
                    <Grid item>
                        <Button type='button' style={{ minWidth: isSmallScreen ? 200 : 'auto' }} onClick={onCancelForm} color='secondary' variant='contained'>Cancel</Button>
                    </Grid>
                    <Grid item>
                        <Button type='submit' style={{ minWidth: isSmallScreen ? 200 : 'auto', backgroundColor: '#3cb371' }} variant='contained' color='primary'>
                            {isAddOperation ? 'Submit' : 'Save'}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}
